import Swal from 'sweetalert2'
import '../styles/style.css'
export function showPopUpErrorMessage(message, isSuccessMessage) {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    iconColor: 'white',
    background: '#ef5350',
    color: '#fff',
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer
      toast.onmouseleave = Swal.resumeTimer
    }
  })

  Toast.fire({
    icon: 'error',
    title: message
  })

  return Toast
}

export function showPopUpSuccessMessage(
  message = 'Success!',
  isSuccessMessage
) {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    iconColor: 'white',
    background: '#28a745',
    color: '#fff',
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer
      toast.onmouseleave = Swal.resumeTimer
    }
  })

  Toast.fire({
    icon: 'success',
    title: message
  })

  return Toast
}

export function showPopUpErrorMessageApi(
  message = 'Error while trying to connect to Server. Please try again.',
  isSuccessMessage
) {
  return showPopUpErrorMessage(message).fire()
}

export function showPopUpConfirmation(
  message = 'Are you sure?',
  confirm = 'Save',
  cancel = 'Cancel',
  functionValue
) {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary-orange',
      cancelButton: 'btn btn-transparent'
    },
    buttonsStyling: false
  })
  return swalWithBootstrapButtons
    .fire({
      title: message,
      showCancelButton: true,
      confirmButtonText: confirm,
      cancelButtonText: cancel,
      reverseButtons: true
    })
    .then((result) => {
      if (result.isConfirmed) {
        Swal.close()
        return false
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        functionValue()
        return
      }
    })
}

export function printDocument(data, isHtml = false) {
  if (isHtml || typeof data === 'string') {
    const printWindow = window.open('', '_blank')
    if (printWindow) {
      printWindow.document.open()
      printWindow.document.write(data)
      printWindow.document.close()
      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.focus()
          printWindow.print()
        }, 300)
      }
      return
    }

    const iframe = document.createElement('iframe')
    iframe.style.position = 'fixed'
    iframe.style.right = '0'
    iframe.style.bottom = '0'
    iframe.style.width = '0'
    iframe.style.height = '0'
    iframe.style.border = '0'
    document.body.appendChild(iframe)

    const doc = iframe.contentWindow.document
    doc.open()
    doc.write(data)
    doc.close()

    setTimeout(() => {
      try {
        iframe.contentWindow.focus()
        iframe.contentWindow.print()
      } catch (e) {
        console.error(e)
      } finally {
        setTimeout(() => {
          if (document.body.contains(iframe)) {
            document.body.removeChild(iframe)
          }
        }, 60000)
      }
    }, 500)
    return
  }

  const url = window.URL.createObjectURL(data)
  const iframe = document.createElement('iframe')
  iframe.style.position = 'fixed'
  iframe.style.right = '0'
  iframe.style.bottom = '0'
  iframe.style.width = '0'
  iframe.style.height = '0'
  iframe.style.border = '0'
  iframe.src = url
  document.body.appendChild(iframe)

  iframe.onload = () => {
    try {
      iframe.contentWindow.focus()
      iframe.contentWindow.print()
    } catch (e) {
      window.open(url)
    } finally {
      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe)
        }
        window.URL.revokeObjectURL(url)
      }, 60000)
    }
  }
}

export const printPdf = printDocument
